import React, { useState, useRef } from "react";
import AddGalleryImageModal from "./AddGalleryImageModal";
import "lightbox2/dist/js/lightbox-plus-jquery";
import "lightbox2/dist/css/lightbox.css";
import "../assets/css/gallery.css";
import arrowRight from "../assets/img/arrow_right.svg";
import arrowLeft from "../assets/img/arrow_left.svg";
import { delete_image_from_gallery } from "../firebase-communication/firebase-database";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

const Gallery = ({ images, parentSliderId, sliderId, reloadData, isAdmin }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const swiperRef = useRef(null);

  const handleAddClick = () => {
    setModalIsOpen(true);
  };

  const handleDeleteImage = async (imageId, imgUrl) => {
    if (window.confirm("Are you sure you want to delete this image?")) {
      try {
        await delete_image_from_gallery(parentSliderId, sliderId, imageId, imgUrl);
        reloadData();
      } catch (error) {
        alert("Failed to delete the image: " + error.message);
      }
    }
  };

  return (
    <div className="galleryContainer">
      <AddGalleryImageModal 
        modalIsOpen={modalIsOpen}
        setModalIsOpen={setModalIsOpen}
        parentSliderId={parentSliderId}
        sliderId={sliderId}
        reloadData={reloadData}
      />

      <Swiper
        observer={true}
        observeParents={true}
        observeSlideChildren={true}
        autoHeight={true}
        grabCursor={true}
        loop={images.length > 1}
        centeredSlides={true}
        spaceBetween={17}
        speed={600}
        modules={[Pagination, Navigation]}
        navigation={{
          nextEl: ".custom-next",
          prevEl: ".custom-prev",
        }}
        pagination={{
          el: ".custom-pagination",
          clickable: true,
        }}
        onSwiper={(s) => (swiperRef.current = s)}
        // onInit={(s) => s.update()}
        onInit={(s) => {
          console.log(s.slides);
          s.update();
          s.slideTo(0, 0, false);
          s.updateAutoHeight();
        }}
        onImagesReady={(swiper) => {
          swiper.updateAutoHeight();
        }}
        onBreakpoint={(swiper) => {
          swiper.update();
        }}
        breakpoints={{
          0: {
            slidesPerView: "auto",
            spaceBetween: 0,
            centerInsufficientSlides: true,
          },
          640: {
            slidesPerView: "auto",
            spaceBetween: 0,
            centeredSlides: true,
            centerInsufficientSlides: true,
          },
          1000: {
            slidesPerView: "auto",
            spaceBetween: 17,
            centeredSlides: true,
            centerInsufficientSlides: true,
          },
        }}
        className="swiperGallery"
      >
        {images.map((image) => (
          <SwiperSlide key={image.id || image.img_url}>
            <img
              src={image.img_url}
              alt=""
              onLoad={() => {
                const s = swiperRef.current;
                if (s) {
                  s.updateAutoHeight();
                  s.update();
                }
              }}
            />
          </SwiperSlide>
        ))}

        {isAdmin && (
          <SwiperSlide key="add-button">
            <div className="galleryItem addButtonContainer" onClick={handleAddClick}>
              <button className="addButton">+</button>
            </div>
          </SwiperSlide>
        )}
      </Swiper>

      <div className="custom-controls">
        <div className="custom-pagination" />
        <div className="button-wrapper">
          <button className="custom-prev">
            <img src={arrowLeft} alt="Previous" />
          </button>
          <button className="custom-next">
            <img src={arrowRight} alt="Next" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Gallery;
